module.exports = __webpack_public_path__ + "img/customer_trobot.2e575d1c.jpeg";